import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './trips.actions.js';
import getters from './trips.getters.js';
import mutations from './trips.mutations.js';
import state from './trips.state.js';

BaseStore.registerModule('trips', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('trips');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
